/**
 * Emailing › « Envoyer un e-mail » (`emailing`): what the page sends, the audience segment, the
 * editor (and the fixed subject), the variables (only when the audience has some — athletes have
 * none, so the step drops for them), the history link, the primary Send with its confirmation.
 */
export const EMAIL_SEND_TOUR = {
    id: 'email-send',
    version: 1,
    paths: ['emailing'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Write to your participants',
            description: 'One e-mail sent to a whole audience of your event: athletes, volunteers or spectators.',
        },
        {
            key: 'audience',
            target: '[data-tour="mail-audience"]',
            placement: 'bottom',
            title: 'Choose the recipients',
            description:
                'Pick the audience: the e-mail goes to everyone in it, the counter tells how many. Spectators appear once ticketing is on.',
        },
        {
            key: 'content',
            // the whole editor, scrolled under the head so its bubble fits below (its toolbar lives in
            // CKEditor's clipped sticky panel, which throws antd's placement off)
            target: '[data-tour="mail-content"]',
            scroll: 'start',
            placement: 'bottom',
            title: 'Write the message',
            description:
                'Write your e-mail here. No subject to enter: it is added automatically. For volunteers and spectators, variable buttons appear below the editor.',
        },
        {
            key: 'variables',
            target: '[data-tour="mail-variables"]',
            placement: 'top',
            title: 'Personalise with variables',
            description:
                'One click inserts a variable, replaced for each recipient by their own first name, role or order.',
        },
        {
            key: 'history',
            target: '[data-tour="mail-history"]',
            placement: 'bottom',
            title: 'Find past e-mails',
            description: 'This button opens the history of every e-mail already sent.',
        },
        {
            key: 'send',
            target: '[data-tour="page-save"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Send',
            description:
                'The line says what is still missing. When everything is ready, the button sends right away after one confirmation. Leaving the page with an unsent draft asks first.',
        },
    ],
}

export default EMAIL_SEND_TOUR
